import React from 'react'
import "./NotFound.css"

export default function NotFound() {

    return <div id="not-found">Nothing here</div>
}